import { getImage } from '../../utils';
import { uploadMedia } from '..';

export const uploadBlogImage = (id) => async (blobInfo, success, failure) => {
  try {
    const payload = {
      ft: 17,
      fi: id,
      ma: blobInfo.blob(),
      mc: blobInfo.filename(),
    };
    const res = await uploadMedia(payload, {
      endpoint: '/media/upload',
    });

    const imgSrc = getImage(res.data.result.media.hash);
    return success(imgSrc);
  } catch (error) {
    failure('مشکلی در هنگام آپلود عکس پیش آمد. لطفا مجددا امتحان کنید.');
  }
};
